import { createSlice } from "@reduxjs/toolkit";
import { getAllThemeList } from "./ThunkActions";
import { iThemeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iThemeState = {
  isLoading: false,
  themeList:[],
  errorMessage: null,
};
export const themeSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetThemeState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllThemeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllThemeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.themeList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(getAllThemeList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      });
  },
});

export const { resetThemeState } = themeSlice.actions;
export default themeSlice.reducer;
